import { CookieConsentsDTO } from "./cookie-consents.dto";

export class CookieConsentsConfigDTO {
  /**
   * Whether or not to show the cookie notice
   */
  showCookieNotice!: boolean;

  /**
   * The user's cookie consent settings
   */
  cookies!: CookieConsentsDTO;

  /**
   * CookieConsentsConfigDTO constructor
   * @param params - Partial configuration for the CookieConsentsConfigDTO
   */
  constructor(params: Partial<CookieConsentsConfigDTO>) {
    Object.assign(this, {
      showCookieNotice: params.showCookieNotice ?? true,
      cookies: params.cookies ?? new CookieConsentsDTO({}),
    });
  }
}
